import type { CSSProperties, ReactNode } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalOverlayPortalProps {
    dataElScope: DataElScope;
    id?: string;
    style: CSSProperties;
}
export function CstretchmodalOverlayPortal({ dataElScope, id, style, }: CstretchmodalOverlayPortalProps): ReactNode {
    if (!id) {
        return id;
    }
    return (
      <div data-el={dataEl(dataElScope, 'OverlayPortal/Root')} id={id} style={style}/>
    );
}
